import { render, staticRenderFns } from "./_TemplatesForm.vue?vue&type=template&id=21f4f4f4&scoped=true&"
import script from "./_TemplatesForm.vue?vue&type=script&lang=ts&"
export * from "./_TemplatesForm.vue?vue&type=script&lang=ts&"
import style0 from "./_TemplatesForm.vue?vue&type=style&index=0&id=21f4f4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f4f4f4",
  null
  
)

export default component.exports